import * as React from 'react';
import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import Col from 'reactstrap/lib/Col';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import Row from 'reactstrap/lib/Row';
import { androidDownloadLink, iOSDownloadLink } from '../../../../../utilities/Utils';
import { HelpEmailLink, HelpPhoneLink } from '../../../../common/HelpLinks';

interface Props {
    isOpen: boolean;
    close: () => void;
    appless: boolean;
}

const StartTourPopup = (props: Props) => {
    return (
        <Modal isOpen={props.isOpen} centered={true}>
            <ModalHeader>{props.appless ? 'Tour Details' : 'Download Tour App'}</ModalHeader>
            <ModalBody className="reschedule-modal">
                {props.appless ? (
                    <div>
                        <p>
                            You should have received an email with all of your tour details. (If you
                            don't see it, check your spam folder for emails from{' '}
                            <a className="email-links" href="mailto:support@tour24now.com">
                                support@tour24now.com
                            </a>
                            .
                        </p>
                        <p>
                            If you have any questions, please contact{' '}
                            <HelpEmailLink className="email-links" />.
                        </p>
                    </div>
                ) : isMobile ? (
                    <>
                        <div>
                            <p>
                                You need to <b>Open</b> the Tour24 App to tour. It contains all the
                                tour information.
                            </p>
                        </div>
                        <div className="app-tour-links-row">
                            {(isIOS || isAndroid) && (
                                <a
                                    className="app-tour-link"
                                    href={isIOS ? iOSDownloadLink : androidDownloadLink}
                                >
                                    <span>Click here.</span>
                                </a>
                            )}
                        </div>
                    </>
                ) : (
                    <div>
                        <p>
                            You need to <b>download the Tour24 app to your mobile phone</b> to take
                            the tour.
                        </p>
                        <p>
                            Please refer to your tour confirmation text message and email for the
                            App Store or Google Play links.
                        </p>
                    </div>
                )}

                <Row>
                    <Col md={12} className="reschedule-popup-buttons">
                        <p className="close-window-button" onClick={props.close}>
                            Close Window
                        </p>
                        <p>Questions?</p>
                        <p>
                            <HelpEmailLink className="email-links" />
                        </p>
                        <p>
                            <HelpPhoneLink className="email-links" />
                        </p>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );
};

export default StartTourPopup;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/tour/applessTour/StartTourPopup.tsx